<script setup lang="ts">
import type { ChampionshipRegistrationStepTask } from "@/model/championship/championship-registration-step-task"
import {
    useChampionshipRegistration,
    type StepProps,
} from "@/pages/Tasks/Tasks/ChampionshipRegistration/useChampionshipRegistration"
import type { TasksProps } from "@/pages/Tasks/Tasks/tasks-props"
import { toRefs } from "vue"
import Step1EditTeam from "./step1_edit_team.vue"
import Step2ShowTeams from "./step2_show_teams.vue"
import Step3Payment from "./step3_payment.vue"
import Step4Final from "./step4_final.vue"
import Step5Cancel from "./step5_cancel.vue"

const props = defineProps<TasksProps<ChampionshipRegistrationStepTask>>()

const emit = defineEmits<{
    (e: "updated"): void
}>()

const { task, issue } = toRefs(props)
const { useStep } = useChampionshipRegistration()
const { item, stepData } = await useStep(issue.value, task.value.championship.id)
const stepProps: StepProps = {
    issue: issue.value,
    task: task.value,
    championship: item.value,
    stepData: stepData.value,
}

function updated() {
    emit("updated")
}
</script>

<template>
    <div v-if="task.state == 'open'">
        <div class="px-3">
            <Step1EditTeam v-if="task.step == 'edit_team'" v-bind="stepProps" @updated="updated"></Step1EditTeam>
            <Step2ShowTeams v-if="task.step == 'show_teams'" v-bind="stepProps" @updated="updated"></Step2ShowTeams>
            <Step3Payment v-if="task.step == 'payment'" v-bind="stepProps" @updated="updated"></Step3Payment>
            <Step4Final v-if="task.step == 'final'" v-bind="stepProps" @updated="updated"></Step4Final>
            <Step5Cancel v-if="task.step == 'cancel'" v-bind="stepProps" @updated="updated"></Step5Cancel>
        </div>
    </div>
</template>
